import dynamic from 'next/dynamic';
import Header from './components/Header';
import Body from './components/Body';

const PresetModal = dynamic(() => import('./components/Modal/PresetModal'), {
  ssr: false,
});
const FinancialModal = dynamic(
  () => import('./components/Modal/FinancialModal'),
  {
    ssr: false,
  },
);

const Screener = () => (
  <>
    <Header />
    <PresetModal />
    <Body />
    <FinancialModal />
  </>
);

export default Screener;
